<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :title="type === 1?'上传头像':'上传社区照片'"
        :visible.sync="imgDialog"
        center
        width="600px">
        <el-form ref="fileForm" :model="fileForm" :rules="rules">

            <el-form-item prop="name">
                <div class="flex align-center justify-around">
                    <el-upload
                        ref="upload"
                        :action="upUrl"
                        :before-upload="beforeAvatarUpload"
                        :data="QiniuData"
                        :name="'file'"
                        :on-success="handleAvatarSuccess"
                        :show-file-list="false"
                        accept="image/*"
                        class="avatar-uploader"
                    >
                        <el-image
                            v-if="imageUrl"
                            :class="{active:type === 2}"
                            :src="imageUrl"
                            class="avatar"
                            fit="contain"></el-image>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>

            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('fileForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('fileForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {FILE_UPLOAD_HOST_QN} from "@/config";
import {addImage, getQiniuUrl} from "@/api/common";
import {getQNToken} from "@/utils/CryptoJS";
import {getQNFileKey} from "@/utils/utils";

export default {
    name: "imgDialog",
    props: {
        imgDialog: {
            type: Boolean,
            default: false
        },
        type: {
            type: Number,
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {

        return {
            upUrl: FILE_UPLOAD_HOST_QN,
            imageUrl: '',
            limit: 1,
            fileForm: {
                url: '',
            },
            rules: {
                url: [{required: true, message: '请选择图片', trigger: 'change'}]
            },
            QiniuData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: getQNToken() //七牛云token
            },
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                token: this.user.token,
                addWatermark: 0
            };
        },
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$refs['upload'].clearFiles()
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addImage(
                this.setId,
                this.type,
                this.fileForm.url,
            );
            this.$message.success(_state.info);
            this.imageUrl = ''
            this.$refs[formName].resetFields();
            this.$refs['upload'].clearFiles()

            this.$emit("cancelDialog", true);
        },
        //  上传钱判断
        beforeAvatarUpload(file) {
            this.QiniuData.fname = file.name;
            this.QiniuData.key = getQNFileKey(`${new Date().getTime()}${file.name}`)
        },
        //  上传成功
       async handleAvatarSuccess(res, file) {
            console.log(res)
            // if (res.status === 200) {
                let _data = await getQiniuUrl(res.key)
                this.imageUrl = _data.data.url
                this.fileForm.url = _data.data.url
            // } else {
            //     this.$message.error(res.info)
            //     this.$refs['upload'].clearFiles()
            // }
        },
    },
    watch: {
        setItem() {
            this.imageUrl = ''
            if (this.type === 1) {
                this.fileForm = {
                    url: this.setItem.avatar
                };
                if (this.setItem.avatar) {
                    this.imageUrl = this.setItem.avatar
                }
            } else {
                this.fileForm = {
                    url: this.setItem.images
                };
                if (this.setItem.images) {
                    this.imageUrl = this.setItem.images
                }
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    display: block;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 150px;
    height: 180px;
    display: block;
    border: 1px dashed #d9d9d9;

    &.active {
        width: 400px;
        height: 300px;
    }
}
</style>
